import { Stack } from "@mantine/core"
import { IconCheck, IconX } from "@tabler/icons-react"
import { Button, Missing, Badge } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import styles from "~/assets/css/StandardCell.module.css"
import { FindProductsProductStandardDto } from "~/gen/api"
import { isStandardCompliant } from "~/pages/Brand/Products/List/Services/standardCompliance"

interface Props {
  value: FindProductsProductStandardDto | undefined
  onClick: (standard: FindProductsProductStandardDto) => void
}
export const StandardCell = ({ value, onClick }: Props) => {
  const { t } = useTranslation("certificates")

  if (!value) return <Missing />

  return (
    <Stack>
      <Button
        onClick={() => onClick(value)}
        h="fit-content"
        w="max-content"
        bg="none"
        p="compact-xs"
        className={styles.standardCell}
      >
        {isStandardCompliant(value) ? (
          <Badge
            text={t("standard.badge.compliant")}
            variant="success"
            icon={<IconCheck size={16} />}
            isShort={true}
            h="fit-content"
            p={0}
          />
        ) : (
          <Badge
            text={t("standard.badge.notCompliant")}
            color="var(--mantine-color-red-6)"
            icon={<IconX size={16} />}
            isShort={true}
            h="fit-content"
            p={0}
          />
        )}
      </Button>
    </Stack>
  )
}
